import { render, staticRenderFns } from "./proposal-list.vue?vue&type=template&id=ad7b8c0e&scoped=true&"
import script from "./proposal-list.vue?vue&type=script&lang=js&"
export * from "./proposal-list.vue?vue&type=script&lang=js&"
import style0 from "./proposal-list.vue?vue&type=style&index=0&id=ad7b8c0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7b8c0e",
  null
  
)

export default component.exports